import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {endpoints} from 'main/tools';
import {Panel} from 'shared/components';
import {EmployeeTableSelector} from 'main/components';

const Employees = observer(({uiState}) => {
  const {policy, errors} = uiState;

  return (
    <div>
      <Panel.Header
        title={t('expenses.manage.policies.edit.steps.Employees')}
        description={t('expenses.manage.policies.edit.Select the employees that will be included in this policy.')}
      />
      <EmployeeTableSelector
        includedEmployees={policy.employees}
        endpoint={endpoints.EXPENSES.POLICIES.ELIGIBLE_EMPLOYEES}
        onChange={employees => policy.setEmployees(employees)}
        errorMessage={errors.employees}
      />
    </div>
  );
});

export default Employees;
